import * as React from "react"

const SvgMegaphoneFilled = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M6.60003 15.06H5.16003C4.36803 15.06 3.69003 14.778 3.12603 14.214C2.56203 13.65 2.28003 12.972 2.28003 12.18V9.29999C2.28003 8.50799 2.56203 7.82999 3.12603 7.26599C3.69003 6.70199 4.36803 6.41999 5.16003 6.41999H10.92L15.924 3.39599C16.404 3.10799 16.89 3.10799 17.382 3.39599C17.874 3.68399 18.12 4.10399 18.12 4.65599V16.824C18.12 17.376 17.874 17.796 17.382 18.084C16.89 18.372 16.404 18.372 15.924 18.084L10.92 15.06H9.48003V19.38C9.48003 19.788 9.34203 20.13 9.06603 20.406C8.79003 20.682 8.44803 20.82 8.04003 20.82C7.63203 20.82 7.29003 20.682 7.01403 20.406C6.73803 20.13 6.60003 19.788 6.60003 19.38V15.06ZM19.56 15.564V5.91599C20.208 6.49199 20.73 7.19399 21.126 8.02199C21.522 8.84999 21.72 9.75599 21.72 10.74C21.72 11.724 21.522 12.63 21.126 13.458C20.73 14.286 20.208 14.988 19.56 15.564Z" />
  </svg>
)
export default SvgMegaphoneFilled
